import React, { useState, useEffect, useRef } from "react";
import "./HomeUms.scss";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import SearchBarComponent from "../../components/searchBar/searchBarComponent";
import { ReactComponent as UsersSVG } from "../../images/new_ui/users.svg";
import { ReactComponent as RolesSVG } from "../../images/new_ui/rolesandpermissions.svg";
import { ReactComponent as SoftwareSVG } from "../../images/new_ui/software-details.svg";
import ReactApexChart from "react-apexcharts";
import logo from "../../images/new_ui/logo-4.png";
import arrow from "../../images/arrow.svg";
import SoftwareImage from "../../components/image/Softwareimage"
import { Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
 
 
const HomeUms = () => {
 
 
 
  const location = useLocation();
  const [RoleName, setRoleName] = useState([]);
  const [activeUserCount, setActiveUserCount] = useState(0);
  const [deactivatedUserCount, setDeactivatedUserCount] = useState(0);
  const [SoftwareData, setSoftwareData]=useState(0);

    useEffect(() => {
      
      getRolesList();
      getUsersList();

  }, []);


     async function getRolesList() {
      setRoleName([])
        dispatch(sidebarReducer.apiLoad(true));
        // setApiLaod(true);
        await axios
    
          .get("roles/list", {
            headers: {
              'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token")
            }
          })
          // .get("userProfile/getAllUsers")
    
          .then((response) => {
         
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));

              setRoleName(response.data.data.rows.map(role => role.te_role_name));
          
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
      async function getSoftwareList(userParam) {
        try {
          const response = await axios.get("/masterpack/list/"+userParam, {
            headers: {
              'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
            }
          });
    
          if (response.status === 200) {
            setSoftwareData(response.data.data);
            console.log("softttttttt",SoftwareData[0].te_bundlename)
  
          }
        } catch (err) {
          console.error("Error fetching user data", err);
        }
      }
      async function getUsersList() {
        try {
          const response = await axios.get("/cmsuser/listActiveUserByCompanyId/"+JSON.parse(sessionStorage.getItem("userdata")).te_companyid, {
            headers: {
              'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
            }
          });
    
          if (response.status === 200) {
            setUserData(response.data.data);
            setActiveUserCount(response.data.data.activeUserCount)
           
            setDeactivatedUserCount(response.data.data.deactivatedUserCount)
          }
        } catch (err) {
          console.error("Error fetching user data", err);
        }
      }
 
  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const navigate = useNavigate();
  let values = {
    series: [activeUserCount, deactivatedUserCount],
    options: {
      dataLabels: {
        enabled: false,
      },
      chart: {
        type: "pie",
      },
      plotOptions: {
        pie: {
          size: 100,
        },
      },
      labels: ["", ""],
 
      stroke: {
        colors: ["#A685FA", "#a685fa8a"],
      },
      theme: {
        monochrome: {
          enabled: true,
        },
      },
      fill: {
        //
        colors: ["#0F0F0F"],
      },
      legend: {
        show: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 50,
            },
            legend: {
              show: false,
            },
          },
        },
      ],
    },
  };
 
  useEffect(() => {
    const params = new URLSearchParams(location.search);
      const userParam = params.get("te_prepid");
      console.log("IDIDID",userParam)
      if (userParam) {
 
        getSoftwareList(userParam);
        
        // Example function call: myFunction(userParam);
      }
  }, [location]);
 
  return (
    <div className="home-ums">
      <div className="container-fluid">
       
        <div className="container">
          <div className="row">
          <SearchBarComponent className="search-bar-div" />
          </div>
          </div>
       
        <div className="container">
          <div className="home-cards">
            <div>
              <div className="title-section">
                <SoftwareSVG
                  style={{
                    width: "40px",
                    height: "auto",
                    margin: "0px 10px",
                    cursor: "default",
                  }}
                />
                Software Details
              </div>
              <div className="card-bottom-section">
                {/* <div className="card-one">
                        <div>
                            <div className="title">Basic Pack</div>
                            <div>Size- 1.2GB <br/> Version- 20.20.3</div>
                        </div>
                        <div>
                            <div><img src={logo} alt="" /></div>
                            <div>Release Date- 20-Oct-2022</div>
                        </div>
                    </div> */}
                      {SoftwareData.length > 0 ? (
                <table>
                 
                  <tr>
                    <td className="title"> {SoftwareData[0].te_bundlename} Pack</td>
                    <td style={{ textAlign: "right" }}>
                    <SoftwareImage className="bundle-pack" style={{ width: "10vw", height: 'auto'}} image={SoftwareData[0].te_softwarelogo} />
                      {/* <img src={logo} alt="" /> */}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Size- {SoftwareData[0].masterpack_bundles[0].te_bundlesizeingb}GB <br /> 
                      Version- {SoftwareData[0].masterpack_bundles[0].te_version}
                    </td>
 
                    <td>Release Date- {new Date(SoftwareData[0].masterpack_bundles[0].te_releasedate).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }).replace(/ /g, '-') || 'N/A'}</td>
                  </tr>
                </table>
                        ) : (
                          <p>Loading software details...</p>
                        )}
              </div>
            </div>
            <div>
              <div className="title-section">
                <UsersSVG
                  style={{
                    width: "40px",
                    height: "auto",
                    margin: "0px 10px",
                    cursor: "default",
                  }}
                />
                Users
              </div>
              <div className="card-bottom-section">
                <div className="card-one">
                  <div id="chart">
                    <ReactApexChart
                      options={values.options}
                      series={values.series}
                      type="pie"
                    />
                  </div>
 
                  <div className="title">{activeUserCount} Active users</div>
                  <div>5 Licenses Remaining</div>
                </div>
 
                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                  <button className="arrowbutton">
                    <img
                      src={arrow}  onClick={() => navigate('/list-users', { state: { isEditing: false } })}
                      style={{ width: "24px", height: "24px" }}
                    />
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div className="title-section">
                <RolesSVG
                  style={{
                    width: "40px",
                    height: "auto",
                    margin: "0px 10px",
                    cursor: "default",
                  }}
                />
                Roles & Permission
              </div>
              <div className="card-bottom-section">
                <div className="title">Roles List</div>
                <div className="roles-list">
                {RoleName.slice(0, 4).map((role, index) => (
                                        <div key={index}>{role}</div>
                                    ))}
               
                </div>
                <br />
                <br />
                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                  <button className="arrowbutton">
                    <img
                      src={arrow}   onClick={() => navigate('/list-roles', { state: { isEditing: false } })}
                      style={{ width: "24px", height: "24px" }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default HomeUms;